import { forwardRef } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { LinkProps } from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

const LinkBehavior = forwardRef((props: any, ref) => {
  const { href, ...other } = props;
  return <RouterLink ref={ref} to={href} {...other} />;
});

const theme = createTheme({
  typography: {
    fontFamily: ["Montserrat", "Serif"].join(","),
    button: {
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: "#e00e1d",
    },
    info: {
      main: "#032844",
    },
    success: {
      main: "#0b6b3a",
    },
  },
  shape: {
    borderRadius: 5,
  },
  // @ts-expect-error
  shadows: ["none", "0px 4px 4px 0px #00000040", ...Array(23).fill("none")],
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      } as LinkProps,
      styleOverrides: {
        root: {
          textDecorationThickness: "2px",
          textUnderlineOffset: "2px",
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { fontSize: "14px", color: "#737373" },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 5,
        },
      },
    },  MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#767676",
        },
      },
    },
  },
});

const MuiThemeProvider = ({ children }: { children: React.ReactNode }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default MuiThemeProvider;
